import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockDataTransformed,
    blockSaveCustomData,
} from '../../../../../../../components/Workspace/components/HocBlock/actions'

import { ADDRESSES_CHANGE_ACTIVE_ADDRESS } from './components/Address/constants'
import {
    ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED,
    ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE,
    ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE,
} from './components/FirmsOnAddress/constants'

import firmsOnAddressSaga from './components/FirmsOnAddress/saga'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.addresses.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const tables = _.get(_action, 'data.data[1]._table', null)

    const transformedData = {
        addressTables: {
            _table: _.map(tables, (table) => ({
                key: _.get(table, 'key', null),
                title: _.get(table, 'title', null),
                tables: _.map(_.get(table, 'tables', []), (x, index) => ({
                    nested: index === 0 && _.get(x, 'historical', false) ? false : _.get(x, 'nested', false),
                    rows: _.map(
                        _.get(x, 'rows', []),
                        (
                            row // eslint-disable-line
                        ) =>
                            _.get(x, 'historical', false) ? { ...row, historical: true } : { ...row, historical: false }
                    ),
                })),
            })),
        },
    }

    // Transformation end
    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    const defaultAddress = _.get(tables, '[0].tables[0].rows[0]', {})
    yield put(blockSaveCustomData(module, id, blockKey, { activeAddress: { ...defaultAddress } }))

    return null
}

function* addressesChangeCustomDataSaga(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.addresses.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(ADDRESSES_CHANGE_ACTIVE_ADDRESS, addressesChangeCustomDataSaga),
        takeEvery(ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED, addressesChangeCustomDataSaga),
        takeEvery(ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE, addressesChangeCustomDataSaga),
        takeEvery(ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE, addressesChangeCustomDataSaga),
        firmsOnAddressSaga(),
    ])
}
